import { DEFAULT_API_CONFIG } from './apiConfig';
import queryString from 'query-string';

const { url, getHeaders } = DEFAULT_API_CONFIG;
const baseRoute = `${url}/inspector`;
const baseAccountRoute = `${url}/account`;

export const getInspectors = async () => {
  const url = `${baseRoute}s`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getInspectorsOptions = async (options = {}) => {
  const q = queryString.stringify(options);
  const url = `${baseRoute}s/options?${q}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getInspector = async id => {
  const url = `${baseRoute}/${id}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getInspectorProfile = async id => {
  const url = `${baseRoute}/${id}/inspectorProfile`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getInspectorProfileSkills = async () => {
  const url = `${baseRoute}/inspectorProfile/skills`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getInspectorsReports = async (startDate, endDate, territoryBased) => {
  const url = `${baseRoute}s/reports?startDateStr=${startDate}&endDateStr=${endDate}&territoryBased=${territoryBased}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });
  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getInspectorOrders = async () => {
  // add a query for IN-REVIEW orders only
  const query = queryString.stringify({ serviceStatusId: [6, 4] });
  // const query = queryString.stringify({ serviceStatusId: 4 });

  const url = `${baseRoute}/orders?${query}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getInspectorOrder = async orderLineId => {
  const url = `${baseRoute}/orders/${orderLineId}`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

export const getInspectorOrderTicket = async orderLineId => {
  const url = `${baseRoute}/orders/${orderLineId}/ticket`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();

  if (!response.ok) {
    return Promise.reject(json);
  }

  // prepare data like QA review
  // get the form definitions
  const orderInfoFormDefinitions = json
    .filter(
      fd => fd.questionCategory === 'Order Info',
      //  && json.find(oifd => oifd.questionId === fd.questionId) === undefined,
    )
    .filter(fd => !fd.question.value.includes('Agent') && !fd.question.value.includes('Mailing')); // hide some fields so they are not displayed

  return orderInfoFormDefinitions;
};

export const getInspectorOrderForms = async orderLineId => {
  const url = `${baseRoute}/orders/${orderLineId}/forms`;
  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'GET',
    headers,
  });

  const json = await response.json();
  return response.ok ? json : Promise.reject(json);
};

/**
 * PUT
 */
export const putInspectorUser = async user => {
  user.role = 'FIELDREP';
  const url = `${baseAccountRoute}/UpdateUser`;

  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(user),
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

export const updateInspectorProfile = async inspector => {
  const url = `${baseRoute}/${inspector.inspectorId}/inspectorProfile`;

  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'PUT',
    body: JSON.stringify(inspector),
    headers,
  });

  return response.ok ? true : Promise.reject(response);
};

/**
 * POST
 */
export const createInspectorUser = async user => {
  user.role = 'FIELDREP';
  user.userName = user.email;
  const url = `${baseAccountRoute}/RegisterUser`;

  let headers = getHeaders();
  const response = await fetch(url, {
    method: 'POST',
    body: JSON.stringify(user),
    headers,
  });

  return response.ok ? await response.json() : Promise.reject(response);
};

export const saveInspectorProfile = async inspector => {
  const createMode = !inspector.inspectorId;

  const url = createMode ? `${baseRoute}/inspectorProfile` : `${baseRoute}/${inspector.inspectorId}/inspectorProfile`;

  const method = createMode ? 'POST' : 'PUT';

  let headers = getHeaders();
  const response = await fetch(url, {
    method,
    body: JSON.stringify(inspector),
    headers,
  });

  if (response.ok) {
    return true;
  }

  const json = await response.json();
  return Promise.reject(json);
};
